<style lang="scss" src='./Newsletter.scss' scoped></style>
<template src="./Newsletter.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getAllNewsletter,
  addNewsletter,
  updateNewsletter,
  deleteNewsletter,

} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Newsletter',
  extends: SecurityComponent,
  components: {
    Placeholder
  },
  data() {
    return {
      newActive: false,
      editMessage: null,
      loading: false,
      messages: [],
      selected_message: {
          title: '',
          content: '',
      },
      course_id: null,
    };
  },
  computed: {
    ...mapState('Courses', {
        courses: (state) => state.courses,
      }),
  },

  methods: {
    ...mapActions('Courses', ['loadCourses']),
    getCourseName(message){
      if(message.course_id){
        let course = this.courses.find(x => x.course_id == message.course_id);
        if(course){
          return course.name;
        }else{
          return '-';
        }
      }
      return this.$t('general.all');
    },
    getSimpleContent(item){
        if(item.content.length > 900){
            let contentLabel = item.content.substr(0,50)
            return contentLabel + '...';
        }
        return item.content; 
    },

    showNewMessageModal() {
      this.newActive = true;
      this.selected_message = {
          title: '',
          content: '',
      }
      this.course_id = null;
      this.$bvModal.show('modal-add')
    },

    showEditMessageModal(item) {
      this.loading = false;
      this.editMessage = item;
      this.selected_message = {...item};
      this.course_id = item.course_id;
      this.newActive = false;
      this.$bvModal.show('modal-add');
    },

    deleteMessage(item){
        if(item.newsletter_id){
            this.G_Alert_v2({ 
            style: this.consts.Style.DANGER, 
            message: this.$t('newsletter.deleteConfirm'),
            fnOk: () => {
                deleteNewsletter(item.newsletter_id)
                .then((res) => {
                    let idx = this.messages.findIndex(item => (item.newsletter_id == res.newsletter_id));
                    if(idx >= 0){
                        this.messages.splice(idx, 1);
                    }
                });
            }
            });
        }
    },
    
    async saveMessage(){
      if(this.selected_message && this.selected_message.title && this.selected_message.title.trim().length > 3 &&
        this.selected_message.content && this.selected_message.content.trim().length > 3
      ){
        
        this.loading = true;
        
        let data = {
          title: this.selected_message.title.trim(),
          content: this.selected_message.content.trim(),
        };

        if(this.newActive) {

          if(this.course_id){
            data['course_id'] = this.course_id;
          }

          await addNewsletter(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add');
          })
        } else {
          await updateNewsletter(data, this.editMessage.newsletter_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadNewsletter();
    },

    loadNewsletter() {
      getAllNewsletter().then((resp) => {
        if (resp && resp.length) {
          this.messages = resp.map(message => ({...message, selected: false}));
        } else {
          this.messages = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Newsletter");
      this.$analytics.logEvent("web_settings_newsletter");
    }

    await this.loadCourses();
    this.loadData();
  },
};

</script>
